/* src/app/views/legal-text-contract/legal-text-contract-maintenance-argentina/legal-text-contract-maintenance-argentina.component.scss */
.contract-summary {
  width: 100%;
  padding-inline: clamp(12px, 3vw, 28px);
  box-sizing: border-box;
}
.contract-created-card {
  width: min(100%, 860px);
  margin: 0 auto;
  padding: clamp(20px, 4vw, 36px);
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
}
.contract-created-content {
  text-align: center;
  color: #102b4e;
}
.contract-created-content h1,
.contract-created-content h3 {
  overflow-wrap: anywhere;
}
.contract-created-content h1 {
  margin: 0 0 12px;
  font-size: clamp(28px, 4.2vw, 40px);
  line-height: 1.1;
}
.contract-created-content h3 {
  margin: 0 0 10px;
  font-size: clamp(16px, 2.4vw, 22px);
  line-height: 1.35;
  font-weight: 400;
}
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 0;
  margin: 0 auto 24px;
  width: 100%;
  max-width: none;
}
.page-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: clamp(16px, 3vw, 28px);
  font-family: Ford Antenna;
  width: 100%;
  box-sizing: border-box;
}
.image-position {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding-inline: clamp(8px, 2vw, 16px);
}
.contract-logo {
  display: block;
  width: min(100%, 380px);
  height: auto;
}
.text-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
  margin-left: 0;
  width: min(1120px, 100%);
}
.styling-the-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
  color: #102b4e;
  font-size: clamp(20px, 2.6vw, 28px);
  line-height: 1.25;
  overflow-wrap: anywhere;
}
.styling-the-hr {
  height: 2px;
  background-color: #102b4e;
  margin-bottom: 20px;
  width: 100%;
}
.top-element {
  position: relative;
  margin: 14px auto;
  width: 100%;
  max-width: 1120px;
  padding-top: 42px;
}
.header {
  width: min(320px, 100%);
  height: calc(100% - 44px);
  background-color: #102b4e;
  color: white;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 0;
  box-shadow: none;
  padding: 12px 0 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  min-height: 64px;
  box-sizing: border-box;
}
.header .header-title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.3px;
  padding: 0;
  background: transparent;
  margin: 0;
  line-height: 1.2;
}
.info-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
  background-color: #D9E2F3;
  padding: 16px 22px;
  color: #102b4e;
  font-size: 14px;
  line-height: 1.42;
  margin-bottom: 0;
  width: calc(100% - 20px);
  max-width: 100%;
  box-sizing: border-box;
  min-height: 96px;
  height: auto;
  overflow-wrap: anywhere;
}
.first-line h5,
.first-line p {
  margin: 0;
}
.elements-below-each-other .first-line {
  gap: 6px;
}
.top-box {
  min-height: 126px;
  gap: 10px;
}
.top-box-second {
  min-height: 118px;
}
.top-box-third {
  min-height: 92px;
}
.top-box-fourth {
  min-height: 96px;
}
.first-line-position {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px 26px;
  width: 100%;
}
.first-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
}
.first-line h5,
.first-line p {
  font-size: 14px;
  line-height: 1.45;
  margin: 0;
  color: #102b4e;
  overflow-wrap: anywhere;
}
.first-line h5 {
  font-weight: 700;
}
.space {
  margin-left: 0;
  justify-content: flex-start;
}
.space-second {
  margin-left: 0;
  justify-content: flex-start;
}
.space-car-image {
  margin-left: 10px;
}
.space-car-image-second {
  margin-left: 0;
  justify-content: flex-start;
}
.space-sifron-image {
  margin-left: 10px;
  flex: 1 1 520px;
}
.space-plan-price {
  margin-left: 10px;
}
.space-price-value {
  margin-left: 0;
  justify-content: flex-start;
}
.icon-style {
  font-size: 56px;
  color: #000000;
  margin-right: 18px;
  margin-left: 6px;
}
.top-box-third .first-line-position {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr) 320px;
  column-gap: 24px;
}
.top-box-fourth .first-line-position {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr) 320px;
  column-gap: 24px;
  align-items: center;
}
.top-box .first-line-position {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  column-gap: 24px;
  align-items: center;
}
.contract-paragraph {
  text-align: justify;
  font-size: 15px;
  line-height: 1.6;
  color: #102b4e;
  margin-top: 10px;
  overflow-wrap: anywhere;
}
.contract-paragraph a {
  color: #046cea;
}
.contract-paragraph a:hover {
  color: #044ea7;
}
.contract-numbered-list,
.contract-numbered-list ol {
  width: 100%;
  margin: 10px 0 0;
  padding-left: 0;
  list-style: none;
  counter-reset: item;
  color: #102b4e;
}
.contract-numbered-list > li,
.contract-numbered-list ol > li {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 10px;
  align-items: start;
  margin-bottom: 14px;
}
.contract-numbered-list > li::before,
.contract-numbered-list ol > li::before {
  content: counters(item, ".") ".";
  counter-increment: item;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.6;
  color: #102b4e;
}
.contract-numbered-list ol {
  margin-top: 8px;
  padding-left: 16px;
}
.contract-numbered-content {
  min-width: 0;
}
.contract-numbered-content > .contract-paragraph:first-child,
.contract-numbered-content > .contract-definition-list:first-child,
.contract-numbered-content > .contract-section-title:first-child {
  margin-top: 0;
}
.contract-section-title {
  margin-top: 0;
  margin-bottom: 10px;
}
.contract-definition-list {
  width: 100%;
  margin: 10px 0 0;
  padding-left: 24px;
  color: #102b4e;
}
.contract-definition-list li {
  text-align: justify;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 10px;
  overflow-wrap: anywhere;
}
@media (max-width: 768px) {
  .top-element {
    padding-top: 30px;
  }
  .header {
    width: min(236px, 100%);
    height: auto;
    min-height: 42px;
    align-items: center;
    padding-top: 0;
  }
  .header .header-title {
    font-size: 13px;
    padding: 7px 0;
  }
  .info-box {
    padding: 12px 14px;
  }
  .first-line-position {
    flex-wrap: wrap;
    gap: 8px 12px;
  }
  .space,
  .space-second,
  .space-car-image,
  .space-car-image-second,
  .space-sifron-image,
  .space-plan-price,
  .space-price-value {
    margin-left: 0;
    justify-content: flex-start;
    flex: 1 1 100%;
  }
  .icon-style {
    font-size: 42px;
    margin-right: 12px;
    margin-left: 2px;
  }
  .top-box-third .first-line-position,
  .top-box-fourth .first-line-position {
    display: flex;
    grid-template-columns: none;
    column-gap: 0;
  }
}
.bold-words {
  font-weight: bold;
}
.image-paragraph {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 20px 0 0;
  padding-inline: clamp(12px, 2vw, 28px);
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.contract-created-action.button-position {
  justify-content: center;
  border-top: 0;
  margin-top: 24px;
  padding-top: 0;
}
.btn-return {
  width: auto;
  min-width: 137px;
  height: 48px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  color: #046cea;
}
.btn-return-span {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  white-space: normal;
  text-align: center;
  line-height: 1.25;
}
.btn-return:hover {
  background: #044ea7;
  color: #ffffff;
}
button.btn-return:hover:not(:disabled) .btn-return-span {
  color: #ffffff;
}
.btn-save {
  width: auto;
  min-width: 137px;
  height: 48px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  color: #ffffff;
}
.btn-save-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: normal;
  text-align: center;
  line-height: 1.25;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return i,
.btn-save i {
  color: inherit;
}
.btn-save:disabled,
.btn-return:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  cursor: not-allowed;
  opacity: 1;
}
.btn-save:disabled .btn-save-span,
.btn-return:disabled .btn-return-span,
.btn-save:disabled i,
.btn-return:disabled i {
  color: #6f6f6f;
}
.btn-save:disabled:hover,
.btn-return:disabled:hover {
  background-color: #f5f5f5;
}
.btn-download {
  width: min(400px, 100%);
  height: 48px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 20px;
  margin-right: 50px;
  color: #ffffff;
}
.btn-download-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: normal;
  text-align: center;
  line-height: 1.25;
}
.btn-download:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
  cursor: not-allowed;
  opacity: 1;
}
.btn-download:disabled .btn-download-span,
.btn-download:disabled i {
  color: #6f6f6f;
}
.btn-download.is-loading {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
}
.btn-download .pi {
  font-size: 18px;
  color: inherit;
}
@media only screen and (max-width: 900px) {
  .top-element {
    max-width: 100%;
  }
  .top-box .first-line-position,
  .top-box-third .first-line-position,
  .top-box-fourth .first-line-position {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    row-gap: 12px;
    column-gap: 0;
  }
  .btn-download {
    width: 100%;
    margin-right: 0;
  }
}
.btn-download:hover:not(:disabled) {
  background: #044ea7;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.elements-below-each-other {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
@media only screen and (max-width: 900px) {
  .top-element {
    padding-top: 34px;
  }
  .header {
    width: min(260px, 100%);
    height: auto;
    min-height: 44px;
    align-items: center;
    padding-top: 0;
  }
  .info-box {
    min-height: unset;
  }
  .first-line-position {
    flex-wrap: wrap;
    gap: 10px;
  }
}
@media only screen and (max-width: 640px) {
  .contract-summary {
    padding-inline: 10px;
  }
  .page-content {
    padding: 14px;
  }
  .top-element {
    padding-top: 0;
  }
  .header {
    position: relative;
    right: auto;
    top: auto;
    width: 100%;
    min-height: 46px;
    border-radius: 12px 12px 0 0;
    margin-bottom: 0;
  }
  .info-box {
    width: 100%;
    padding: 14px;
  }
  .top-box,
  .top-box-second,
  .top-box-third,
  .top-box-fourth {
    min-height: unset;
  }
  .button-position {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 10px;
  }
  .contract-created-action.button-position {
    flex-direction: column;
  }
  .btn-return,
  .btn-save,
  .btn-download {
    width: 100%;
    min-width: 0;
    margin-right: 0;
    padding-inline: 16px;
  }
  .btn-return-span,
  .btn-save-span,
  .btn-download-span {
    font-size: 12pt;
  }
  .contract-numbered-list > li,
  .contract-numbered-list ol > li {
    column-gap: 8px;
  }
  .contract-definition-list {
    padding-left: 18px;
  }
}
/*# sourceMappingURL=legal-text-contract-maintenance-argentina.component-BJZYAFAS.css.map */
